import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductBasePriceUnit = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productBasePriceUnit =
    product[`base_price_unit_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productBasePriceUnit) {
    apmCaptureError(
      new Error(
        `GK_AIR: product base price unit not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productBasePriceUnit
}
